var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { emptyMarket } from "../../constants";
import { fillEmptyMarketSelections } from "../";
export var prepareEmptyMarket = function (cardProps, template, index) {
    var emptyLocalMarket = __assign({}, emptyMarket);
    emptyLocalMarket.id = cardProps.event.id + "-empty-" + index;
    emptyLocalMarket.selections = fillEmptyMarketSelections(template);
    emptyLocalMarket.template = template;
    return emptyLocalMarket;
};
//# sourceMappingURL=prepareEmptyMarket.js.map